/**
 * キーワード検索の入力文字列を GA に送る前の PII ガード／正規化。
 *
 * GA4 はメール・電話等の PII を送ると規約違反になる。フリーワードには個人情報が
 * 入り得る前提で、送信前に正規化（trim・小文字化・長さ制限）し、メールらしき入力は送らない。
 */
const MAX_KEYWORD_LENGTH = 100;

/**
 * 入力キーワードを正規化する。
 * メールらしき入力（`@` を含む）は PII リスクのため空文字を返し、実値を送らない。
 * タグ直接選択などで入力が無い場合も空文字。
 */
export const normalizeSearchKeyword = (raw: string | undefined | null): string => {
  if (!raw) return '';
  const normalized = raw.trim().toLowerCase();
  if (!normalized) return '';
  // 長さ制限の前に `@` を判定する（切り詰めで `@` が落ちて PII ガードをすり抜けるのを防ぐ）
  if (normalized.includes('@')) return '';
  return normalized.slice(0, MAX_KEYWORD_LENGTH);
};
